import debug from 'debug';

const log = debug('Authentication');

class Authentication {
	Authenticated() {
		const settings = Authentication.getSettings();
		return settings.authenticated.toLowerCase() === 'true' ? true : false;
	}

	static getSettings() {
		let settings;

		try {
			settings = JSON.parse(document.body.getAttribute('data-authentication'));
			if (!settings || !settings.authenticated) {
				log('Authentication settings is not set in BODY');
			}
		}
		catch(error) {
			log(error);
		}

		return settings;
	}

	/**
	 * @returns {boolean}
	 */
	static isAuthenticated() {
		const settings = Authentication.getSettings();
		return settings.authenticated.toLowerCase() === 'true' ? true : false;
	}
}

export default Authentication;
